import { render, staticRenderFns } from "./IconBadge.vue?vue&type=template&id=50d98096&scoped=true&"
import script from "./IconBadge.vue?vue&type=script&lang=js&"
export * from "./IconBadge.vue?vue&type=script&lang=js&"
import style0 from "./IconBadge.vue?vue&type=style&index=0&id=50d98096&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d98096",
  null
  
)

export default component.exports